export default __webpack_public_path__ + "Src/Client/Tiles/ProductTile/productTile.html";